//@flow
import { ChatActions } from 'common/modules/chat/redux/actions/chat';
import { ChatState } from 'common/modules/chat/models/internal/ChatState';

const initialState = ChatState.fromJS({
    isConnected: false,
    isChatWindowOpen: false,
    userProfile: null,
    unreadChannelCount: 0
});

type ActionType = {
    type: string,
    payload: any
};

export default (
    state: ChatState = initialState,
    action: ActionType
): ChatState => {
    switch (action.type) {
        case ChatActions.CONNECT_CHAT_SDK:
            return state.setIsConnected(true);
        case ChatActions.DISCONNECT_CHAT_SDK:
            return state.setIsConnected(false);
        case ChatActions.SHOW_CHAT_WINDOW:
            return state.setIsChatWindowOpen(true);
        case ChatActions.HIDE_CHAT_WINDOW:
            return state.setIsChatWindowOpen(false);
        case ChatActions.SET_USER_PROFILE:
            return state.setUserProfile(action.payload);
        case ChatActions.SET_UNREAD_CHANNEL_COUNT:
            return state.setUnreadChannelCount(action.payload);
        default:
            return state;
    }
};
